import Cookies from 'js-cookie';
// import nookies from 'nookies';
import {Language} from '../../../context/LanguageContext';
import {useCallback, useState} from 'react';
import {useUser} from '../../../hooks';
import {Close} from '@material-ui/icons';
import {APIURL} from '../../../consts';

export default function FormRename({data, title, onSubmit, onClose}) {
  const tokens_session = Cookies.get('token');
  // const cookies = nookies.get();
  // const tokens_session = cookies.token;
  const {language, newObj} = Language();
  const [name, setName] = useState('');

  const handleSubmit = useCallback(
    async (e) => {
      try {
        e.preventDefault();
        onSubmit(name);
      } catch (error) {
      } finally {
        onClose();
      }
    },
    [tokens_session, language, data, name]
  );

  return (
    <div className="modal_content center add_folder">
      <div className="modal_header">
        <p className="modal_title">{title}</p>
        <Close
          style={{cursor: 'pointer'}}
          onClick={() => {
            onClose();
          }}
        />
      </div>
      <div className="modal_body ">
        <form
          action="POST"
          className="add_folder_form"
          onSubmit={(e) => {
            handleSubmit(e);
          }}
        >
          <div className="add_folder_input">
            <input
              type="text"
              value={name}
              name="name"
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="modal_flexible_btn_ctr">
            <button type="submit">{newObj.SaveWord[language]}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
